import { createFileRoute } from '@tanstack/react-router';
import { redirectToHealthReadiness } from '@/components/health-readiness/legacy-redirect';

/** The old Health Check → Interviews tab (T-0224, T-0242): the Interview notes tab. */
export const Route = createFileRoute('/engagements/$engagementId/health/interviews')({
  beforeLoad: ({ params }) => {
    throw redirectToHealthReadiness(params.engagementId, { tab: 'interviews' });
  },
});
